import React from 'react'
import './Users.css'

const Users: React.FC = () => {
  return (
    <div className="users-page">
      <div className="page-header">
        <h2>Quản lý người dùng</h2>
      </div>

      <div className="coming-soon-card">
        <div className="coming-soon-icon">👥</div>
        <h3>Tính năng đang phát triển</h3>
        <p>
          Trang quản lý người dùng đang được phát triển và sẽ sớm có mặt trong phiên bản tiếp theo.
        </p>
        <div className="features-list">
          <h4>Các tính năng sắp tới:</h4>
          <ul>
            <li>Xem danh sách người dùng</li>
            <li>Thêm/sửa/xóa tài khoản</li>
            <li>Phân quyền người dùng</li>
            <li>Quản lý trạng thái tài khoản</li>
            <li>Lịch sử hoạt động</li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Users